import s1 from '@/assets/img/shape/free-delivery.png'
import s2 from '@/assets/img/shape/factory-direct.png'
import s3 from '@/assets/img/shape/Custom-inquery.png'
import s4 from '@/assets/img/shape/no-minimum-order.png'
// import sl1 from '@/assets/img/svg/services/services-light-1.svg'
// import sl2 from '@/assets/img/svg/services/services-light-2.svg'
import sl3 from '@/assets/img/svg/services/services-light-3.svg'
import sl4 from '@/assets/img/svg/services/services-light-4.svg'

import blog1 from '@/assets/img/banner/Borneo_Stole_update.jpg'
import blog2 from '@/assets/img/banner/chair.jpg'
// import blog3 from '@/assets/img/home-v3/blog.jpg'

export const servicesData = [
    {
        id:1,
        image:s1,
        title:'Free Delivery',
        product:'dont worry for shipping cost,free delivery for jakarta, tanggerang and bekasi',
        desc:''
    },
    {
        id:2,
        image:s2,
        title:'Factory Direct',
        product:'All Product we tell, directly from the Factory',
    },
    {
        id:3,
        image:s3,
        image2:sl3,
        title:'Custom Inquary',
        product:'we create custom handmade furniture. based on your inquary',
    },
    {
        id:4,
        image:s4,
        image2:sl4,
        title:'No Minimum Order',
        product:'Budget Friendly with no minimum or small quantity order',
    },
]

export const blogData = [
    {
        image:blog1,
        tag:' BORNE STOOL   ',
        title:'Design for small space ',
        br : "for your home"
    },
    {
        image:blog2,
        // date:'5th May 2025',
        tag:'JAMIE CHAIR',
        title:' High Quality Furniture',
        br : "for your home"
    },
    
]